// actions
import * as Actions from "actions";
// helpers
import { getJsonFromUrl } from "helpers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
// component
import WrapperProfilePage from "../component/WrapperProfilePage";

const mapStateToProps = (state) => ({
  user: state.user,
  tags: state.tags,
  unions: state.unions,
  subscriptions: state.subscriptions,
});

const mapDispatchToProps = (dispatch) => ({
  getMemberById: (...args) => dispatch(Actions.getMemberById(...args)),

  getInstruments: (...args) => dispatch(Actions.getInstruments(...args)),

  updateBazaarCustomer: (...args) =>
    dispatch(Actions.updateBazaarCustomer(...args)),

  updateMember: (...args) => dispatch(Actions.updateMember(...args)),
  deleteMember: (...args) => dispatch(Actions.deleteMember(...args)),
  inviteMember: (...args) => dispatch(Actions.inviteMember(...args)),

  updateContact: (...args) => dispatch(Actions.updateContact(...args)),
  deleteContact: (...args) => dispatch(Actions.deleteContact(...args)),
  createContact: (...args) => dispatch(Actions.createContact(...args)),

  updateMemberInstrument: (...args) =>
    dispatch(Actions.updateMemberInstrument(...args)),
  deleteMemberInstrument: (...args) =>
    dispatch(Actions.deleteMemberInstrument(...args)),
  createMemberInstrument: (...args) =>
    dispatch(Actions.createMemberInstrument(...args)),

  getTags: (...args) => dispatch(Actions.getTags(...args)),
  getUnions: (...args) => dispatch(Actions.getUnions(...args)),
  getSubscriptions: (...args) => dispatch(Actions.getSubscriptions(...args)),

  createMemberTag: (...args) => dispatch(Actions.createMemberTag(...args)),
  deleteMemberTag: (...args) => dispatch(Actions.deleteMemberTag(...args)),

  createMemberUnion: (...args) => dispatch(Actions.createMemberUnion(...args)),
  deleteMemberUnion: (...args) => dispatch(Actions.deleteMemberUnion(...args)),
});
class ProfilePage extends Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    user: PropTypes.object,

    updateBazaarCustomer: PropTypes.func,

    updateMember: PropTypes.func,
    deleteMember: PropTypes.func,
    inviteMember: PropTypes.func,

    getInstruments: PropTypes.func,

    updateContact: PropTypes.func,
    deleteContact: PropTypes.func,
    createContact: PropTypes.func,

    updateMemberInstrument: PropTypes.func,
    deleteMemberInstrument: PropTypes.func,
    createMemberInstrument: PropTypes.func,

    tags: PropTypes.array,
    unions: PropTypes.array,
    getTags: PropTypes.func,
    getUnions: PropTypes.func,

    createMemberTag: PropTypes.func,
    deleteMemberTag: PropTypes.func,

    createMemberUnion: PropTypes.func,
    deleteMemberUnion: PropTypes.func,

    subscriptions: PropTypes.array,
    getSubscriptions: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { location, getTags, getUnions, getSubscriptions } = this.props;
    const urlParams = getJsonFromUrl(location);
    this.state = {
      urlParams,
      memberID: urlParams.id || "me",
      loading: true,
    };

    getSubscriptions();
    getTags();
    getUnions();

    this.refresh();
  }

  async refresh() {
    const { getMemberById } = this.props;
    const { memberID } = this.state;

    const resp = await getMemberById(memberID);
    if (resp && resp.success) {
      this.setState({
        member: resp.payload,
        refreshKey: new Date().getTime(),
        loading: false,
      });
    }
  }

  render() {
    const {
      location,
      history,
      updateBazaarCustomer,
      updateMember,
      getInstruments,
      updateContact,
      deleteContact,
      createContact,
      updateMemberInstrument,
      deleteMemberInstrument,
      createMemberInstrument,
      tags,
      unions,
      createMemberTag,
      deleteMemberTag,
      createMemberUnion,
      deleteMemberUnion,
      inviteMember,
      subscriptions,
      user,
      deleteMember,
    } = this.props;

    const { urlParams, refreshKey, member, loading } = this.state;

    const accountSuperadmin =
      user.services &&
      user.services.account &&
      user.services.account.findIndex((s) => s === "superadmin");
    const local420Admin =
      user.services &&
      user.services.local420 &&
      user.services.local420.findIndex((s) => s === "admin");

    return (
      <WrapperProfilePage
        history={history}
        location={location}
        urlParams={urlParams}
        loading={loading}
        member={member}
        deleteMember={deleteMember}
        refreshKey={refreshKey}
        getInstruments={getInstruments}
        updateBazaarCustomer={updateBazaarCustomer}
        updateMember={updateMember}
        updateContact={updateContact}
        deleteContact={deleteContact}
        createContact={createContact}
        inviteMember={inviteMember}
        updateMemberInstrument={updateMemberInstrument}
        deleteMemberInstrument={deleteMemberInstrument}
        createMemberInstrument={createMemberInstrument}
        tags={tags}
        user={user}
        unions={unions}
        createMemberTag={createMemberTag}
        deleteMemberTag={deleteMemberTag}
        createMemberUnion={createMemberUnion}
        deleteMemberUnion={deleteMemberUnion}
        subscriptions={subscriptions}
        refresh={this.refresh.bind(this)}
        admin={accountSuperadmin >= 0 || local420Admin >= 0}
        edit={member && member.userUUID === user.uuid}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
